.quillDisplayContainer * {
    font-family: Lato,Helvetica,Arial,sans-serif;
    font-size: 1rem;
    line-height: 1.5;
    color: rgba(0,0,0,.87);
    text-align: left;
}

.quillDisplayContainer *[class*="ql-editor"] {
    padding: 0 !important;
}